import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { downloadScreenshotOptions } from "@/api";

/**
 * A feedback screenshot as an object URL. The image endpoint needs the bearer
 * token, so a plain <img src> can't load it: fetch the bytes through the
 * generated client, then expose a blob URL (revoked on change/unmount).
 */
export function useScreenshotUrl(feedbackUuid: string, blobName: string) {
  const query = useQuery({
    ...downloadScreenshotOptions({ path: { feedback_uuid: feedbackUuid, blob_name: blobName }, parseAs: "blob" }),
    staleTime: Number.POSITIVE_INFINITY,
  });
  const blob = query.data as Blob | undefined;
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!blob) return;
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => {
      URL.revokeObjectURL(objectUrl);
      setUrl(undefined);
    };
  }, [blob]);

  return { url, isError: query.isError, isPending: query.isPending };
}
